// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__chCA2","label":"Section_label__2fpuL","contentWrap":"Section_contentWrap__xeRUq","footer":"Section_footer__1Zw-s","footerInner":"Section_footerInner__13DSj"};